import { ManagedUserGroup } from "types/generated";

export type ApiKeyGroupMappingEntity = Pick<
  ManagedUserGroup,
  "id" | "groupName" | "description"
> & {
  status: ApiKeyGroupMappingStatus;
};

export enum ApiKeyGroupMappingStatus {
  MAPPED = "MAPPED",
  UNMAPPED = "UNMAPPED",
}
